import { useContext } from 'react'
import { AuthContext } from '../../contexts/auth/auth.context'
import type { TAuthContextValue } from '../../contexts/auth/auth.types'

export const useAuth = (): TAuthContextValue => {
  const context = useContext(AuthContext)

  if (!context) {
    throw new Error(
      'useAuth must be used within an <AuthProvider>. ' +
      'Wrap your application with <AuthProvider> to use this hook.',
    )
  }

  return context
}
